import React from "react";
import "./container.css";

const Container = ({ children, justifyContent, alignItems, flexDirection }) => (
  <div className="container" style={{ justifyContent, alignItems, flexDirection }}>
    {children}
  </div>
);

export default Container;



// WEBPACK FOOTER //
// ./src/components/container/container-component.js